module.exports = __webpack_public_path__ + "static/media/de_anubis.f47632c5.jpg";